export default {
  title: '灯源网-导购系统',
  systemLogo: 'http://imgqn.dengyuan.vip/static/logo-yuan.png',
  // 接口前缀
  api: {
    development: 'http://127.0.0.1:8081/api/', // 开发模式
    // development: 'https://api.dengyuan.vip/api/', // 开发模式
    production: 'https://api.dengyuan.vip/api/' // 生产模式
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js